import {Component} from '@angular/core';
import {AutoScraperBackendService} from "../auto-scraper-backend.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {SupplierImplementation} from "../model";
import {catchError} from "rxjs/operators";
import {EMPTY} from "rxjs";
import {environment} from "../../environments/environment";

@Component({
    selector: 'app-page-type',
    templateUrl: './page-classification.component.html',
    styleUrls: ['./page-classification.component.css'],
    standalone: false
})
export class PageClassificationComponent {
  status_message: string = ""

  constructor(private http: HttpClient, public data: AutoScraperBackendService) {

  }

  /** Trains page-type classification by POSTing the implementation; on success updates the implementation and sets status_message. */
  do_classification_training() {
    const headers = new HttpHeaders({
      'auth': this.data.token
    });

    this.http.post(environment.apiUrl + "/page_type_classification", this.data.supplier_implementation, {headers}).pipe(
      catchError((error) => {
        this.status_message = "Error. Are all 6 page sources non-empty?"
        return EMPTY
      })
    ).subscribe((res) => {
      if (typeof res === "string") {
          this.status_message = res
          const page_type_classification = this.data.supplier_implementation.page_type_classification
          page_type_classification.method_of_page_type_classification = null
          page_type_classification.no_hits_unique_html_identifiers = []
          page_type_classification.direct_hit_unique_html_identifiers = []
          page_type_classification.multiple_hits_unique_html_identifiers = []
          page_type_classification.no_hits_amount_of_json_keys = 0
          page_type_classification.no_hit_phrase_recommended = false
          return
        }

      this.data.supplier_implementation = res as SupplierImplementation

      if (this.data.supplier_implementation.page_type_classification.method_of_page_type_classification != null) {
        this.status_message = "Success"
      }
      else {
        this.status_message = "No method of page classification found."
      }
    });
  }
}
